'use client';

import { sendCustomEvent } from '../../analytics';
import HiddenLink from '../HiddenLink';

const url = new URL(
  process.env.NODE_ENV === 'development' ? 'http://localhost:3000/' : 'https://www.lapki-pets.by/'
);

export default function CallToNumber({
  phoneNo,
  path
}: {
  phoneNo: string | undefined;
  path: string | undefined;
}) {
  return (
    <HiddenLink>
      <a
        className="text-lg text-blue-600 underline sm:text-base dark:text-yellow-300"
        href={`tel:${phoneNo}`}
        onClick={() => {
          sendCustomEvent({
            action: 'click_call',
            url: `${url}/${path}`
          });
        }}
      >
        {phoneNo}
      </a>
    </HiddenLink>
  );
}
